import { render, staticRenderFns } from "./ProductDetailMovil.vue?vue&type=template&id=6ec29d26"
import script from "./ProductDetailMovil.vue?vue&type=script&lang=js"
export * from "./ProductDetailMovil.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailMovil.vue?vue&type=style&index=0&id=6ec29d26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports